import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconSticker: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="sticker, badge"><path fillRule="evenodd" clipRule="evenodd" d="M2 12C2 6.47715 6.47715 2 12 2C12.9072 2 13.7068 2.42482 14.2863 3.00434L20.9957 9.71368C21.5752 10.2932 22 11.0928 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12ZM20.5073 11.4578C16.0071 12 12.0073 8 12.5494 3.5L20.5073 11.4578Z" fill="currentColor"/></CentralIconBase>;
};

export default IconSticker;
